var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.053,
    height: 14.699,
    viewBox: "0 0 21.053 14.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,16.1V5.237q0-.019.057-.358L6.52,10.347.147,16.475A1.6,1.6,0,0,1,.072,16.1ZM.92,4.125a.813.813,0,0,1,.321-.057H18.456a1.068,1.068,0,0,1,.339.057L12.384,9.611l-.848.679L9.858,11.667,8.18,10.29l-.848-.679ZM.939,17.21l6.43-6.166,2.489,2.018,2.489-2.018,6.43,6.166a.905.905,0,0,1-.321.057H1.241a.854.854,0,0,1-.3-.057ZM13.2,10.347l6.373-5.468a1.125,1.125,0,0,1,.057.358V16.1a1.445,1.445,0,0,1-.057.377Z",
    transform: "translate(0.678 -3.318)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminders);
export default __webpack_public_path__ + "static/media/Reminders.4fceb2803f7d77759686437de92f69f0.svg";
export { ForwardRef as ReactComponent };